import { render, staticRenderFns } from "./GamanzaInit.vue?vue&type=template&id=4ba3c0c5"
import script from "./GamanzaInit.vue?vue&type=script&lang=js"
export * from "./GamanzaInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports